const es = {
  common: {
    home: 'Inicio',
    loading: 'Cargando...',
    and: 'y'
  },
  language: {
    label: 'Idioma',
    english: 'Ingles',
    spanish: 'Espanol',
    greek: 'Griego'
  },
  header: {
    downloadFreeVersion: 'Descargar version gratis',
    searchPlaceholder: 'Ctrl + K',
    wizard: 'Crear Evento',
    openNotifications: 'abrir notificaciones',
    notificationsTitle: 'Notificaciones',
    markAllReadTooltip: 'Marcar todo como leido',
    viewAllNotifications: 'Ver todo'
  },
  menu: {
    navigation: 'Navegacion',
    dashboard: 'Panel',
    events: 'Eventos',
    people: 'Personas',
    upgrade: 'Mejorar plan',
    administrators: 'Administradores',
    users: 'Usuarios',
    scheduled: 'Programados',
    queue: 'Cola',
    queueAll: 'Cola - Todo',
    queueCompleted: 'Cola - Completado',
    queueNotCompleted: 'Cola - No completado',
    queueOverdue: 'Cola - Atrasado',
    queueEmail: 'Cola - Email',
    queueSms: 'Cola - SMS',
    queueViber: 'Cola - Viber',
    queueTelegram: 'Cola - Telegram',
    transactions: 'Transacciones',
    emailTemplates: 'Plantillas de correo',
    eventTemplates: 'Plantillas de evento',
    authentication: 'Autenticacion',
    login: 'Iniciar sesion',
    register: 'Registrarse',
    utilities: 'Utilidades',
    typography: 'Tipografia',
    color: 'Color',
    shadow: 'Sombra',
    support: 'Soporte',
    samplePage: 'Pagina de ejemplo',
    documentation: 'Documentacion'
  },
  footer: {
    rightsReserved: 'Todos los derechos reservados',
    hireUs: 'Contratanos',
    license: 'Licencia',
    terms: 'Terminos',
    figmaDesignSystem: 'Sistema de diseno Figma'
  },
  dashboard: {
    title: 'Panel',
    apiHealth: 'Salud de API',
    checking: 'Verificando...',
    currentUser: 'Usuario actual',
    signedIn: 'Sesion iniciada',
    signedInAccount: 'Cuenta con sesion iniciada',
    userRole: 'Usuario',
    sessionInvalid: 'Sesion invalida',
    loginAgain: 'Inicia sesion de nuevo',
    totalOrder: 'Pedidos totales',
    totalSales: 'Ventas totales',
    totalEvents: 'Total de eventos',
    totalEventsDesc: 'Todos tus eventos',
    totalPeople: 'Total de personas',
    totalPeopleDesc: 'Personas activas en tu lista',
    nextEvent: 'Proximo evento',
    noUpcomingEvent: 'Sin eventos proximos',
    today: 'Hoy',
    days: 'dias',
    incomeOverview: 'Resumen de ingresos',
    thisWeekStatistics: 'Estadisticas de esta semana',
    recentOrders: 'Pedidos recientes',
    recentAnswers: 'Respuestas recientes',
    recentAnswersTable: {
      event: 'Evento',
      name: 'Nombre',
      email: 'Email',
      phone: 'Telefono',
      countPerson: 'Personas',
      status: 'Estado',
      noData: 'Aun no hay respuestas.',
      statusAttending: 'Asistira',
      statusDeclined: 'Declino',
      statusMaybe: 'Tal vez',
      statusPending: 'Pendiente'
    },
    exportCsv: 'Exportar CSV',
    exportExcel: 'Exportar Excel',
    printTable: 'Imprimir tabla',
    analyticsReport: 'Reporte analitico',
    weekly: 'Semanal',
    monthly: 'Mensual',
    yearly: 'Anual',
    financeGrowth: 'Crecimiento financiero',
    expensesRatio: 'Ratio de gastos',
    businessRiskCases: 'Casos de riesgo',
    low: 'Bajo',
    transactionHistory: 'Historial de transacciones',
    recentNotifications: 'Notificaciones recientes',
    noNotifications: 'Sin notificaciones aun',
    justNow: 'Ahora mismo',
    minutesAgo: 'Hace {{count}}m',
    hoursAgo: 'Hace {{count}}h',
    daysAgo: 'Hace {{count}}d',
    helpSupportChat: 'Chat de ayuda y soporte',
    typicalReply: 'Respuesta tipica en 5 min',
    needHelp: 'Necesitas ayuda?',
    financeOverview: 'Resumen Financiero',
    income: 'Ingresos',
    expenses: 'Gastos',
    month: 'Mes',
    week: 'Semana',
    noFinanceData: 'Agrega datos financieros a tus eventos para ver el gráfico aquí',
    goToEvents: 'Ir a Eventos',
    welcome: {
      heading: 'Bienvenido a EventList',
      subtitle: 'Todo lo que necesitas para planificar y gestionar tus eventos — invitaciones, invitados, mesas y finanzas — en un solo lugar.',
      cta: 'Crea tu primer evento',
      step1Title: 'Crear evento',
      step1Desc: 'Configura tu evento con nombre, fecha, ubicación y todos los detalles clave.',
      step2Title: 'Agregar invitados',
      step2Desc: 'Crea tu lista de invitados y envía hermosas invitaciones por correo electrónico.',
      step3Title: 'Gestionar mesas',
      step3Desc: 'Asigna invitados a mesas y organiza la disposición de asientos con facilidad.',
      step4Title: 'Control financiero',
      step4Desc: 'Registra ingresos y gastos para mantener el presupuesto de tu evento bajo control.'
    }
  },
  upgradePage: {
    title: 'Mejorar a Premium',
    subtitle: 'Desbloquea funciones avanzadas para tu equipo con un unico plan Premium.',
    discountBadge: 'Ahorra 30%',
    returnHint: 'Despues del pago exitoso, volveras automaticamente a la pagina de agradecimiento.',
    month: 'mes',
    year: 'ano',
    billingMonthly: 'Mensual',
    billingYearly: 'Anual',
    billedAnnually: 'Facturado EUR {{price}} / ano',
    yearlyDiscount: '30% de descuento en plan anual',
    choosePlan: 'Elegir plan',
    processing: 'Redirigiendo al pago...',
    packages: {
      premium: 'Premium'
    },
    features: {
      unlimitedCustomers: 'Enviar a clientes ilimitados',
      unlimitedEvents: 'Crear eventos e invitaciones ilimitadas',
      emailSmsViberTelegram: 'Canales de email, SMS, Viber y Telegram',
      advancedAnalytics: 'Analiticas avanzadas y seguimiento de entregas',
      prioritySupport: 'Soporte prioritario con respuesta mas rapida',
      multiTeamAccess: 'Acceso multi-equipo y gestion de roles'
    },
    errors: {
      loadCatalog: 'No se pudieron cargar los planes de facturacion.',
      planUnavailable: 'Este plan no esta disponible temporalmente. Intentalo de nuevo.',
      checkoutFailed: 'No se pudo crear la sesion de pago. Intentalo de nuevo.'
    }
  },
  upgradeThankYou: {
    title: 'Gracias por tu pago',
    subtitle: 'Estamos confirmando tu paquete. Puedes continuar usando el panel.',
    processing: 'Procesando la confirmacion de tu pago...',
    success: 'Pago completado correctamente. Los beneficios de tu plan ya estan activos.',
    missingPaymentReference: 'No se encontro referencia de pago en la URL de retorno.',
    backToUpgrade: 'Volver a Mejorar',
    goToDashboard: 'Ir al Panel',
    errors: {
      completeFailed: 'Fallo la confirmacion del pago. Contacta soporte si se te cobro.'
    }
  },
  mobileCheckoutResult: {
    successTitle: 'Pago realizado con exito',
    successMessage: 'Tu pago se completo correctamente. Puedes cerrar esta pagina y volver a la app.',
    failedTitle: 'Pago no completado',
    failedMessage: 'Tu pago no se completo o fue cancelado. Puedes cerrar esta pagina y volver a la app.',
    pendingTitle: 'Pago recibido',
    pendingMessage: 'Puedes cerrar esta pagina y volver a la app.'
  },
  eventsPage: {
    title: 'Eventos',
    createNewEvent: 'Crear nuevo evento',
    loadingEvents: 'Cargando eventos...',
    searchLabel: 'Buscar',
    searchPlaceholder: 'Buscar por titulo, tipo, lugar o direccion',
    pageSize: 'Tamano de pagina',
    results: 'Mostrando {{shown}} de {{total}} eventos',
    noEvents: 'Aun no hay eventos. Crea tu primer evento.',
    noEventsMatchSearch: 'No hay eventos que coincidan con tu busqueda.',
    noEventsMatchFilters: 'Ningun evento coincide con los filtros de metodos de envio seleccionados.',
    edit: 'Editar',
    view: 'Ver',
    createEvent: 'Crear evento',
    editEvent: 'Editar evento',
    viewEvent: 'Ver evento',
    save: 'Guardar',
    saveChanges: 'Guardar cambios',
    cancel: 'Cancelar',
    close: 'Cerrar',
    guestsTitle: 'Invitados',
    loadingGuests: 'Cargando invitados...',
    noGuests: 'No se encontraron invitados para este evento.',
    eventFallback: 'Evento',
    table: {
      actions: 'Acciones',
      edit: 'Editar',
      title: 'Titulo',
      occasion: 'Ocasion',
      eventType: 'Tipo de evento',
      status: 'Estado',
      sendProviders: 'Metodos de envio',
      scheduledLocal: 'Programado (local)',
      createdLocal: 'Creado (local)',
      venue: 'Lugar',
      guests: 'Invitados',
      tablesLockedForPastEvent: 'Las mesas estan bloqueadas porque la fecha del evento ya paso.'
    },
    actions: 'Acciones',
    manageTables: 'Mesas',
    status: {
      readyToSend: 'Listo para enviar',
      sending: 'Enviando',
      sent: 'Enviado'
    },
    sendDateMode: {
      immediately: 'Inmediato',
      scheduled: 'Programado'
    },
    details: {
      title: 'Detalles del evento',
      status: 'Estado',
      sendDateMode: 'Modo de envio',
      templateName: 'Nombre de la plantilla',
      totalGuests: 'Total de invitados'
    },
    form: {
      title: 'Titulo',
      occasionType: 'Tipo de ocasion',
      eventType: 'Tipo de evento',
      scheduledDateTime: 'Fecha y hora programada',
      venue: 'Lugar',
      address: 'Direccion',
      timeZone: 'Zona horaria',
      defaultLanguage: 'Idioma predeterminado',
      sendProviders: 'Metodos de envio',
      replyBeforeDays: 'Plazo de respuesta (dias antes del evento)',
      replyBeforeDaysHelp: 'Numero de dias antes del evento en que los invitados deben responder. Dejar vacio para sin plazo.'
    },
    filters: {
      status: 'Filtrar por estado',
      allStatuses: 'Todos los estados',
      sendProvider: 'Filtrar por metodo de envio',
      allSendProviders: 'Todos los metodos de envio',
      sortBySendProvider: 'Ordenar por metodo de envio',
      showFilters: 'Mostrar filtros',
      hideFilters: 'Ocultar filtros',
      none: 'Sin orden',
      ascending: 'A a Z',
      descending: 'Z a A',
      tableView: 'Vista de tabla',
      cardView: 'Vista de tarjetas'
    },
    card: {
      template: 'Plantilla',
      templatePreview: 'Vista previa de plantilla',
      noImage: 'Sin imagen de vista previa'
    },
    pagination: {
      previous: 'Anterior',
      next: 'Siguiente',
      goToPage: 'Ir a pagina',
      pageOf: 'Pagina {{page}} de {{totalPages}}'
    },
    eventTypeOptions: {
      other: 'Otro',
      wedding: 'Boda',
      birthday: 'Cumpleanos',
      conference: 'Conferencia',
      meeting: 'Reunion',
      party: 'Fiesta'
    },
    backToEvents: 'Volver a Eventos',
    guestsTable: {
      name: 'Nombre',
      email: 'Correo',
      phone: 'Telefono',
      countPerson: 'Cantidad',
      preferredLanguage: 'Idioma',
      status: 'Estado',
      url: 'URL publica',
      copyUrl: 'Copiar URL',
      copyWishlistUrl: 'Copiar Enlace de Regalos',
      copied: 'Copiado',
      resend: 'Reenviar',
      resending: 'Reenviando...',
      resendSuccess: 'Invitacion reenviada a {{name}}.',
      log: 'Log',
      lastAnswerLocal: 'Ultima respuesta',
      tableNumber: 'Mesa',
      logHistoryTitle: 'Log de respuestas del invitado',
      logAction: 'Accion',
      logActionResponded: 'El invitado respondio',
      logDateLocal: 'Fecha (hora local)',
      loadingLog: 'Cargando historial de respuestas...',
      logFilter: 'Filtro',
      logFilterToday: 'Hoy',
      logFilterLast7Days: 'Ultimos 7 dias',
      logFilterAll: 'Todo',
      noLogEntries: 'Aun no hay entradas en el log de respuestas.',
      quickViewTitle: 'Detalles del invitado',
      rsvpStatus: 'Estado RSVP',
      invitationCode: 'Codigo de invitacion',
      scanCode: 'Codigo de escaneo',
      statusChanged: 'Estado actualizado para {{name}}.',
      countPersonChanged: 'Cantidad de personas actualizada para {{name}}.',
      checkedIn: 'Registrado',
      addGuest: 'Agregar Invitado',
      addGuestTitle: 'Agregar Nuevo Invitado',
      addGuestSuccess: '{{name}} ha sido agregado como invitado.',
      sendToUnsent: 'Enviar a No Enviados',
      sendToUnsentHint: 'Use "Enviar a No Enviados" para enviar invitaciones a los invitados que fueron agregados pero aún no han recibido un mensaje.',
      sendToUnsentSuccess: 'Invitaciones enviadas a {{count}} invitado(s) sin envío.',
      allAlreadySent: 'Todos los invitados ya han recibido una invitación.',
      addFromContacts: 'Desde Contactos',
      addFromContactsTitle: 'Agregar Invitados desde Contactos',
      addFromContactsSuccess: '{{count}} contacto(s) agregados como invitados.',
      searchContactsPlaceholder: 'Buscar por nombre, email o teléfono',
      noContactsMatch: 'No se encontraron contactos.',
      noContactsAvailable: 'Todos los contactos ya fueron agregados a este evento.',
      contactsAvailable: '{{count}} contactos disponibles ({{selected}} seleccionados)',
      addSelected: 'Agregar {{count}} Seleccionados',
      remove: 'Eliminar',
      removeGuestTitle: 'Eliminar Invitado',
      removeGuestConfirm: '¿Está seguro de que desea eliminar a {{name}} de este evento? Esta acción no se puede deshacer.',
      removeGuestSuccess: '{{name}} ha sido eliminado de este evento.'
    },
    rsvp: {
      accepted: 'Aceptado',
      rejected: 'Rechazado',
      maybe: 'Quizas',
      pending: 'Pendiente'
    },
    errors: {
      backendUnavailable: 'No se puede alcanzar la API backend en {{baseUrl}}. Inicia la API con: dotnet run --project src/Backend/EventList.Api',
      loadEvents: 'No se pueden cargar los eventos ahora.',
      loadEventDetails: 'Error al cargar los detalles del evento.',
      loadGuests: 'Error al cargar invitados.',
      loadGuestLog: 'Error al cargar el log de respuestas del invitado.',
      createEvent: 'Error al crear evento.',
      updateEvent: 'Error al actualizar evento.',
      resendInvitation: 'Error al reenviar la invitacion.',
      resendTemplateNotFound: 'No se encontro una plantilla compatible para este invitado.',
      changeStatus: 'Error al cambiar el estado del invitado.',
      changeCountPerson: 'Error al actualizar la cantidad de personas.',
      addGuest: 'Error al agregar invitado.',
      removeGuest: 'Error al eliminar invitado.'
    },
    validation: {
      titleMax: 'El titulo debe tener 120 caracteres o menos',
      titleRequired: 'El titulo es obligatorio',
      occasionTypeMax: 'El tipo de ocasion debe tener 60 caracteres o menos',
      occasionTypeRequired: 'El tipo de ocasion es obligatorio',
      scheduledAtRequired: 'La fecha y hora son obligatorias',
      venueMax: 'El lugar debe tener 160 caracteres o menos',
      venueRequired: 'El lugar es obligatorio',
      addressMax: 'La direccion debe tener 240 caracteres o menos',
      addressRequired: 'La direccion es obligatoria',
      timeZoneMax: 'La zona horaria debe tener 100 caracteres o menos',
      timeZoneRequired: 'La zona horaria es obligatoria',
      defaultLanguageMax: 'El idioma debe tener 10 caracteres o menos',
      defaultLanguageRequired: 'El idioma predeterminado es obligatorio',
      sendProviderMax: 'El metodo de envio debe tener 40 caracteres o menos',
      sendProviderRequired: 'El metodo de envio es obligatorio'
    }
  },
  tablesPage: {
    title: 'Mesas',
    backToEvents: 'Volver a eventos',
    backToTables: 'Volver a mesas',
    print: 'Imprimir',
    printViewTitle: 'Vista de impresion de mesas',
    printViewSubtitle: 'Resumen de asientos para impresion',
    eventDetails: 'Detalles del evento',
    detailEventName: 'Nombre del evento',
    detailEventType: 'Tipo de evento',
    detailDateLocal: 'Fecha (local)',
    detailVenue: 'Lugar',
    detailAddress: 'Direccion',
    detailTimeZone: 'Zona horaria',
    detailDefaultLanguage: 'Idioma predeterminado',
    detailAssignedGuests: 'Invitados asignados',
    detailAssignedPersons: 'Personas asignadas',
    detailTotalTables: 'Total de mesas',
    noAssignedTables: 'Aun no hay asignaciones de mesas.',
    tableGuestCount: '{{count}} invitados',
    tablePersonCount: '{{count}} personas',
    loading: 'Cargando mesas del evento...',
    eventFallback: 'Evento',
    summary: 'Invitados: {{totalGuests}}. Asignados: {{assignedGuests}}. Sin asignar: {{unassignedGuests}}.',
    capacityLabel: 'Personas por mesa',
    countModeLabel: 'Contar invitados para recomendacion',
    tableCountLabel: 'Mesas a mostrar',
    rsvpFilterLabel: 'Filtrar invitados por RSVP',
    hardLockLabel: 'Bloqueo estricto de capacidad',
    hardLockOn: 'Activado (bloquea drops con sobrecapacidad)',
    hardLockOff: 'Desactivado (permite sobrecapacidad temporal)',
    applyRecommended: 'Usar sugerencia',
    autoAssign: 'Asignar automatico',
    clear: 'Limpiar asignaciones',
    save: 'Guardar mesas',
    saving: 'Guardando...',
    recommendation: '{{guests}} invitados / {{capacity}} por mesa = {{tables}} mesas necesarias.',
    occupancy: '{{count}} / {{capacity}}',
    overCapacityWarning: 'Capacidad superada en mesa(s): {{tables}}. Reduce cada mesa a maximo {{capacity}} invitados.',
    lockBlocked: 'No se puede soltar en la mesa {{tableNumber}} porque ya alcanzo su capacidad ({{capacity}}).',
    declinedBlocked: 'Los invitados con estado RSVP Rechazado no pueden asignarse a mesas.',
    pastEventLocked: 'Las asignaciones de mesas estan bloqueadas porque este evento ya paso.',
    unassigned: 'Invitados sin mesa',
    emptyUnassigned: 'Todos los invitados tienen mesa asignada.',
    tableTitle: 'Mesa {{tableNumber}}',
    dropHint: 'Arrastra invitados aqui',
    filteredViewHint: 'Mostrando {{shown}} de {{total}} invitados para el filtro actual.',
    rsvpFilter: {
      all: 'Todos los estados RSVP',
      attending: 'Asistira',
      maybe: 'Quizas',
      pending: 'Pendiente',
      declined: 'Rechazado'
    },
    countMode: {
      all: 'Todos excepto rechazados',
      attendingOnly: 'Solo asistentes'
    },
    success: {
      saved: 'Se guardaron mesas para {{count}} invitados.'
    },
    errors: {
      backendUnavailable: 'No se puede alcanzar la API backend en {{baseUrl}}. Inicia la API con: dotnet run --project src/Backend/EventList.Api',
      missingEventId: 'Falta el id del evento en la ruta.',
      load: 'Error al cargar mesas del evento.',
      save: 'Error al guardar asignaciones de mesas.'
    },
    premiumGate: {
      title: 'Funcion Premium',
      description: 'La gestion de mesas esta disponible solo para suscriptores Premium. Actualiza tu plan para acceder a la asignacion de asientos.',
      upgrade: 'Actualizar a Premium'
    },
    invitationGate: {
      title: 'Invitaciones aun no enviadas',
      description: 'La gestion de mesas estara disponible una vez que se hayan enviado las invitaciones. Primero envia las invitaciones y luego podras gestionar las asignaciones de mesas.'
    }
  },
  wizardPage: {
    title: 'Asistente de creacion de eventos',
    loading: 'Cargando datos del asistente...',
    steps: {
      createEvent: 'Crear evento',
      selectTemplate: 'Seleccionar plantilla',
      selectPeople: 'Seleccionar personas',
      preview: 'Vista previa',
      confirmAndSend: 'Confirmar y enviar'
    },
    actions: {
      backToEvents: 'Volver a eventos',
      back: 'Atras',
      next: 'Siguiente'
    },
    form: {
      title: 'Titulo del evento',
      occasionType: 'Tipo de ocasion',
      eventType: 'Tipo de evento',
      status: 'Estado',
      scheduledDateTime: 'Fecha y hora programadas',
      sendDateMode: 'Fecha de envio',
      sendDateTime: 'Fecha y hora de envio',
      sendProviders: 'Metodos de envio',
      venue: 'Lugar',
      address: 'Direccion',
      defaultLanguage: 'Idioma predeterminado',
      timeZone: 'Zona horaria',
      replyBeforeDays: 'Plazo de respuesta (dias antes del evento)',
      replyBeforeDaysHelp: 'Numero de dias antes del evento en que los invitados deben responder. Dejar vacio para sin plazo.'
    },
    status: {
      readyToSend: 'Listo para enviar',
      sending: 'Enviando',
      sent: 'Enviado'
    },
    sendDateMode: {
      immediately: 'Inmediatamente',
      scheduled: 'Programar fecha y hora'
    },
    templates: {
      noPhoto: 'Sin foto',
      previewAlt: 'Imagen de vista previa de plantilla',
      language: 'Idioma',
      photoSchema: 'Esquema de foto: 200px x 200px',
      filterEventType: 'Filtrar por tipo de evento',
      filterLanguage: 'Filtrar por idioma',
      all: 'Todos',
      other: 'Otro',
      noResultsForFilters: 'Ninguna plantilla coincide con los filtros seleccionados.'
    },
    table: {
      select: 'Seleccionar',
      action: 'Accion',
      name: 'Nombre',
      email: 'Correo',
      phone: 'Telefono',
      countPerson: 'Cantidad de personas'
    },
    people: {
      createPerson: 'Crear persona',
      editPerson: 'Edicion rapida',
      importAvailability: 'Importar disponibilidad (Excel)',
      selectAll: 'Seleccionar todo',
      deselectAll: 'Deseleccionar todo',
      dialogTitle: 'Crear persona',
      editDialogTitle: 'Editar persona',
      fullNameLabel: 'Nombre completo',
      emailLabel: 'Correo',
      phoneLabel: 'Telefono',
      availabilityLabel: 'Disponibilidad',
      countPersonLabel: 'Cantidad de personas',
      availabilityPlaceholder: 'Ejemplo: Lun-Vie 09:00-18:00',
      importDialog: {
        title: 'Importar disponibilidad desde Excel',
        description: 'Sube un archivo Excel para crear o actualizar personas y su disponibilidad en lote.',
        supportedColumns: 'Las columnas compatibles y sus alias se muestran abajo.',
        columnFullName: 'Full Name (o Name)',
        columnEmail: 'Email',
        columnPhone: 'Phone (o Phone Number)',
        columnAvailability: 'Availability (o Available)',
        columnCountPerson: 'Count Person (o Count / People Count / Persons)',
        downloadDemo: 'Descargar Excel de ejemplo',
        chooseFile: 'Seleccionar archivo Excel',
        changeFile: 'Cambiar archivo',
        selectedFile: 'Archivo seleccionado',
        noFileSelected: 'Ningun archivo seleccionado',
        progressText: 'Importando fila {{current}} de {{total}}',
        resultSummary: 'Resultado de importacion: anadidos {{added}}, actualizados {{updated}}, omitidos {{skipped}}, fallidos {{failed}}.',
        rowErrorsTitle: 'Errores por fila',
        rowErrorItem: 'Fila {{row}}: {{message}}',
        downloadErrors: 'Exportar filas con error',
        skippedRowsTitle: 'Filas omitidas',
        skippedRowsSummary: 'Se omitieron {{count}} filas porque Full Name y Email estaban vacios.',
        skippedReason: 'Faltan Full Name y Email',
        downloadSkippedRows: 'Exportar filas omitidas',
        cancel: 'Cancelar',
        import: 'Importar',
        importing: 'Importando...'
      },
      cancel: 'Cancelar',
      save: 'Guardar',
      create: 'Crear',
      saving: 'Guardando...',
      creating: 'Creando...',
      success: {
        personCreated: 'Persona creada y seleccionada correctamente.',
        personUpdated: 'Persona actualizada correctamente.',
        importComplete: 'Importacion de Excel completa. Anadidos {{added}}, actualizados {{updated}}.'
      },
      errors: {
        createPerson: 'Error al crear la persona.',
        updatePerson: 'Error al actualizar la persona.',
        fullNameEmailRequired: 'El nombre completo y el correo son obligatorios.',
        invalidEmail: 'Por favor, introduce una direccion de correo valida.',
        importFailed: 'No se pudo importar este archivo. Sube un archivo .xlsx o .xls valido.',
        importApiError: 'Error al importar personas desde Excel.',
        fileRequired: 'Selecciona un archivo Excel para importar.',
        emptyFile: 'El archivo Excel seleccionado esta vacio.'
      }
    },
    preview: {
      eventSummary: 'Resumen del evento',
      title: 'Titulo',
      occasion: 'Ocasion',
      eventType: 'Tipo de evento',
      when: 'Cuando',
      status: 'Estado',
      sendDateMode: 'Fecha de envio',
      sendDateTime: 'Fecha y hora de envio',
      venue: 'Lugar',
      address: 'Direccion',
      timeZone: 'Zona horaria',
      defaultLanguage: 'Idioma predeterminado',
      sendProviders: 'Metodos de envio',
      selectedTemplate: 'Plantilla seleccionada',
      previewInvitation: 'Vista previa de invitacion',
      closePreview: 'Cerrar vista previa',
      noTemplateSelected: 'No hay plantilla seleccionada',
      recipients: 'Destinatarios',
      peopleSelected: '{{count}} personas seleccionadas',
      countPersonSelected: '{{count}} asistentes totales seleccionados'
    },
    confirm: {
      description: 'Listo para crear el evento, adjuntar las personas seleccionadas como invitados y enviar invitaciones.',
      confirmAndSend: 'Confirmar y enviar',
      eventId: 'Id del evento'
    },
    warnings: {
      noTemplates: 'No se encontraron plantillas de invitacion. Crea al menos una plantilla para poder enviar invitaciones.',
      noPeople: 'No se encontraron personas. Agrega personas primero desde la pagina Personas.'
    },
    validation: {
      titleRequired: 'El titulo del evento es obligatorio.',
      occasionTypeRequired: 'El tipo de ocasion es obligatorio.',
      eventTypeRequired: 'El tipo de evento es obligatorio.',
      scheduledRequired: 'La fecha y hora son obligatorias.',
      sendDateRequired: 'La fecha y hora de envio son obligatorias cuando se programa el envio.',
      venueRequired: 'El lugar es obligatorio.',
      addressRequired: 'La direccion es obligatoria.',
      timeZoneRequired: 'La zona horaria es obligatoria.',
      sendProviderRequired: 'El metodo de envio es obligatorio.',
      templateRequired: 'Selecciona una plantilla.',
      peopleRequired: 'Selecciona al menos una persona.'
    },
    errors: {
      backendUnavailable: 'No se puede alcanzar la API backend. Verifica que EventList.Api este ejecutandose.',
      loadTemplates: 'Error al cargar plantillas.',
      loadPeople: 'Error al cargar personas.',
      loadWizardData: 'Error al cargar los datos del asistente.',
      createEvent: 'Error al crear el evento.',
      updateEvent: 'Error al actualizar el evento.',
      eventIdMissing: 'La API de eventos no devolvio un id de evento.',
      addGuests: 'Error al agregar las personas seleccionadas como invitados.',
      sendInvitations: 'Error al enviar invitaciones.',
      completeWizard: 'Error al completar el asistente.'
    },
    success: {
      sent: 'Las invitaciones se enviaron correctamente.',
      scheduled: 'El evento esta en readyToSend. Las invitaciones estan programadas para {{sendAt}}.',
      queuedScheduled: 'Gracias. Tu mensaje se ha puesto en cola y se enviara el {{sendAt}}.',
      queuedImmediately: 'Gracias. Tu mensaje se ha puesto en cola y se enviara inmediatamente.'
    }
  },
  publicInvitation: {
    title: 'Invitacion',
    loading: 'Cargando invitacion...',
    welcome: 'Hola {{guestName}}',
    eventTitle: 'Evento',
    occasion: 'Ocasion',
    scheduled: 'Fecha y hora',
    venue: 'Lugar',
    address: 'Direccion',
    currentResponse: 'Respuesta actual',
    answerPrompt: 'Por favor elige tu respuesta',
    responseSaved: 'Tu respuesta ha sido guardada.',
    viewWishlist: 'Ver la lista de regalos',
    actions: {
      agree: 'Aceptar',
      dontKnow: 'No se',
      reject: 'Rechazar'
    },
    countPersonDialog: {
      title: '¿Cuántas personas?',
      description: 'Por favor ingrese el número total de personas que asistirán (incluyéndose a usted).',
      confirm: 'Confirmar',
      cancel: 'Cancelar'
    },
    errors: {
      backendUnavailable: 'No se puede alcanzar la API backend en {{baseUrl}}. Inicia la API con: dotnet run --project src/Backend/EventList.Api',
      invalidInvitation: 'Este enlace de invitacion es invalido o ha expirado.',
      loadInvitation: 'No se puede cargar la invitacion ahora.',
      submitRsvp: 'No se puede enviar tu respuesta ahora.'
    }
  },
  auth: {
    login: {
      title: 'Iniciar sesion',
      noAccount: '¿No tienes una cuenta?',
      emailLabel: 'Correo electronico',
      emailPlaceholder: 'Ingresa tu correo',
      passwordLabel: 'Contrasena',
      passwordPlaceholder: 'Ingresa tu contrasena',
      keepSignedIn: 'Mantenerme conectado',
      forgotPassword: '¿Olvidaste tu contrasena?',
      button: 'Iniciar sesion',
      invalidCredentials: 'Correo o contrasena invalidos.',
      unableToLogin: 'No se puede iniciar sesion ahora. Por favor intenta de nuevo.'
    },
    forgotPassword: {
      title: 'Olvide mi contrasena',
      backToLogin: 'Volver al inicio de sesion',
      emailLabel: 'Correo electronico',
      emailPlaceholder: 'Ingresa tu correo',
      button: 'Enviar enlace de recuperacion',
      success: 'Si el correo existe, se envio un enlace de recuperacion.',
      error: 'No se pudo enviar el enlace ahora. Intenta de nuevo.'
    },
    resetPassword: {
      title: 'Restablecer contrasena',
      backToLogin: 'Volver al inicio de sesion',
      passwordLabel: 'Nueva contrasena',
      passwordPlaceholder: 'Ingresa tu nueva contrasena',
      confirmPasswordLabel: 'Confirmar contrasena',
      confirmPasswordPlaceholder: 'Repite la nueva contrasena',
      button: 'Restablecer contrasena',
      success: 'Tu contrasena fue restablecida exitosamente. Ya puedes iniciar sesion.',
      error: 'No se pudo restablecer la contrasena. El enlace puede haber expirado.',
      invalidToken: 'Token invalido o faltante. Solicita un nuevo enlace de recuperacion.',
      confirmPasswordRequired: 'Por favor confirma tu contrasena',
      passwordsMustMatch: 'Las contrasenas deben coincidir'
    },
    confirmEmail: {
      title: 'Confirma tu direccion de correo',
      backToLogin: 'Volver al inicio de sesion',
      instructions: 'Haz clic en el boton para confirmar tu direccion de correo.',
      button: 'Confirmar correo',
      successTitle: 'Gracias!',
      successMessage: 'Tu direccion de correo fue confirmada. Ya puedes iniciar sesion.',
      checkInboxTitle: 'Revisa tu bandeja de entrada',
      checkInboxMessage: 'Te enviamos un enlace de confirmacion. Abrelo para verificar tu correo.',
      checkInboxEmail: 'Correo de confirmacion enviado a: {{email}}',
      error: 'No se pudo confirmar tu correo ahora. El enlace puede ser invalido o haber expirado.'
    },
    register: {
      title: 'Registrarse',
      haveAccount: '¿Ya tienes una cuenta?',
      firstNameLabel: 'Nombre*',
      lastNameLabel: 'Apellido*',
      phoneLabel: 'Telefono',
      emailLabel: 'Correo electronico*',
      passwordLabel: 'Contrasena',
      confirmPasswordLabel: 'Confirmar contrasena',
      firstNamePlaceholder: 'Juan',
      lastNamePlaceholder: 'Garcia',
      countryCodePlaceholder: '+34',
      phonePlaceholder: '600123456',
      emailPlaceholder: 'demo@empresa.com',
      agreeText: 'Al registrarte, aceptas nuestros',
      termsOfService: 'Terminos de servicio',
      privacyPolicy: 'Politica de privacidad',
      button: 'Crear cuenta',
      unableToRegister: 'No se puede crear tu cuenta ahora. Por favor intenta de nuevo.',
      emailAlreadyExists: 'Ya existe una cuenta con este correo. Por favor inicia sesion.',
      goToLogin: 'Ir a Iniciar sesion',
      successToast: 'Cuenta creada. Revisa tu correo para confirmar tu direccion.',
      welcome: {
        defaultName: 'amigo',
        title: 'Bienvenido, {{firstName}}',
        instructions: {
          line1: 'Tu cuenta esta lista y ahora puedes comenzar a organizar eventos.',
          line2: 'Usa el panel para crear eventos, gestionar invitados y seguir respuestas.',
          line3: 'Si es tu primera visita, comienza con el panel principal.'
        },
        goToDashboard: 'Ir al Panel de Administracion'
      }
    },
    validation: {
      mustBeValidEmail: 'Debe ser un correo valido',
      emailRequired: 'El correo es obligatorio',
      passwordRequired: 'La contrasena es obligatoria',
      passwordNoSpaces: 'La contrasena no puede comenzar ni terminar con espacios',
      passwordTooLongLogin: 'La contrasena debe tener menos de 100 caracteres',
      passwordTooLongRegister: 'La contrasena debe tener menos de 10 caracteres',
      firstNameRequired: 'El nombre es obligatorio',
      lastNameRequired: 'El apellido es obligatorio',
      confirmPasswordRequired: 'Por favor confirma tu contrasena',
      passwordsMustMatch: 'Las contrasenas deben coincidir'
    }
  },
  profile: {
    title: 'Perfil',
    aria: {
      openProfile: 'abrir perfil',
      profileUserAlt: 'usuario del perfil',
      profileTabs: 'pestanas de perfil'
    },
    defaults: {
      adminUser: 'Usuario admin',
      administrator: 'Administrador'
    },
    tabs: {
      profile: 'Perfil',
      setting: 'Configuracion'
    },
    menu: {
      editProfile: 'Editar perfil',
      viewProfile: 'Ver perfil',
      socialProfile: 'Perfil social',
      billing: 'Facturacion',
      billingHistory: 'Historial de cargos',
      renewSubscription: 'Renovar suscripcion',
      logout: 'Cerrar sesion'
    },
    settingMenu: {
      support: 'Soporte',
      accountSettings: 'Configuracion de cuenta',
      privacyCenter: 'Centro de privacidad',
      feedback: 'Comentarios',
      history: 'Historial'
    },
    fields: {
      email: 'Correo',
      role: 'Rol',
      firstName: 'Nombre',
      lastName: 'Apellido',
      fullName: 'Nombre completo',
      birthday: 'Fecha de nacimiento',
      invoiceEnabled: 'Necesito datos de facturacion',
      invoiceCompanyName: 'Empresa / Nombre de factura',
      invoiceVatNumber: 'Numero de IVA',
      invoiceAddressLine1: 'Direccion linea 1',
      invoiceAddressLine2: 'Direccion linea 2',
      invoiceCity: 'Ciudad',
      invoicePostalCode: 'Codigo postal',
      invoiceCountry: 'Pais'
    },
    edit: {
      title: 'Editar perfil',
      subtitle: 'Actualiza tu informacion personal y los datos opcionales de facturacion.',
      successSaved: 'Perfil guardado correctamente.',
      currentDisplayName: 'Nombre para mostrar actual: {{name}}',
      actions: {
        save: 'Guardar perfil',
        reset: 'Restablecer',
        viewProfile: 'Ver perfil',
        backToDashboard: 'Volver al panel'
      }
    },
    view: {
      title: 'Ver perfil',
      accountLoadError: 'No se pudieron cargar los datos de la cuenta desde el servidor.',
      invoiceNotEnabled: 'Los datos de facturacion no estan habilitados.',
      sections: {
        account: 'Cuenta',
        personalInformation: 'Informacion personal',
        invoiceDetails: 'Datos de facturacion'
      },
      actions: {
        editProfile: 'Editar perfil',
        backToDashboard: 'Volver al panel',
        refreshLocalData: 'Actualizar datos locales'
      },
      deleteAccount: {
        button: 'Eliminar Cuenta',
        dialogTitle: '¿Eliminar tu cuenta?',
        warning: 'Esto eliminará permanentemente tu cuenta, eventos y todos los datos asociados. Esta acción no se puede deshacer.',
        sendCode: 'Enviar código de eliminación',
        codePrompt: 'Introduce el código de 6 dígitos enviado a tu correo',
        codePlaceholder: '000000',
        confirmDeletion: 'Confirmar Eliminación',
        resendCode: 'Reenviar código',
        resendCooldown: 'Reenviar en {{seconds}}s',
        cancel: 'Cancelar'
      }
    }
  },
  billingHistoryPage: {
    title: 'Historial de cargos',
    subtitle: 'Revisa tu estado de facturacion y la actividad reciente de cobros.',
    loading: 'Cargando datos de facturacion...',
    comingSoon: 'Historial detallado de cargos disponible pronto',
    note: 'Puedes renovar tu suscripcion ahora y el detalle de facturas aparecera aqui cuando el endpoint de historial este disponible.',
    yes: 'Si',
    no: 'No',
    summary: {
      premiumAccess: 'Acceso premium',
      premiumUntil: 'Premium hasta',
      smsCredits: 'Creditos SMS',
      maxGuests: 'Max invitados / evento',
      smsEnabled: 'SMS habilitado'
    },
    actions: {
      renewSubscription: 'Renovar suscripcion',
      backToDashboard: 'Volver al panel'
    },
    errors: {
      load: 'No se pudo cargar el estado de facturacion en este momento.'
    }
  },
  adminTransactionsPage: {
    title: 'Todas las transacciones',
    subtitle: 'Los administradores pueden revisar transacciones de facturacion de todos los usuarios.',
    loading: 'Cargando transacciones...',
    empty: 'Aun no hay transacciones.',
    noMatches: 'Ninguna transaccion coincide con los filtros actuales.',
    filters: {
      status: 'Estado',
      allStatuses: 'Todos los estados',
      userEmail: 'Correo del usuario',
      userEmailPlaceholder: 'Buscar por correo',
      createdFrom: 'Creado desde',
      createdTo: 'Creado hasta',
      sort: 'Orden',
      pageSize: 'Tamano de pagina',
      clear: 'Limpiar',
      results: 'Mostrando {{shown}} de {{total}} transacciones'
    },
    sort: {
      createdDesc: 'Mas nuevas primero',
      createdAsc: 'Mas antiguas primero',
      toggleToNewest: 'Ordenar por mas nuevas primero',
      toggleToOldest: 'Ordenar por mas antiguas primero'
    },
    pagination: {
      previous: 'Anterior',
      next: 'Siguiente',
      pageOf: 'Pagina {{page}} de {{totalPages}}'
    },
    status: {
      pending: 'Pendiente',
      completed: 'Completado',
      failed: 'Fallido'
    },
    table: {
      created: 'Creado',
      user: 'Usuario',
      plan: 'Plan',
      amount: 'Importe',
      status: 'Estado',
      completed: 'Completado',
      externalPaymentId: 'ID de pago externo',
      transactionId: 'ID de transaccion'
    },
    errors: {
      backendUnavailable: 'No se puede alcanzar la API en {{baseUrl}}. Inicia la API con: dotnet run --project src/Backend/EventList.Api',
      load: 'No se pudieron cargar las transacciones en este momento.'
    }
  },
  notificationsPage: {
    title: 'Todas las notificaciones',
    description: 'Esta pagina usa la misma plantilla de notificaciones que el panel del encabezado para poder agregar mas tipos en el futuro.',
    unreadCount: '{{count}} sin leer',
    noMatches: 'No hay notificaciones que coincidan con este filtro.',
    filters: {
      all: 'Todo',
      unread: 'Sin leer',
      rsvp: 'RSVP',
      billing: 'Facturacion',
      invitations: 'Invitaciones',
      newUsers: 'Nuevos usuarios',
      newEvents: 'Nuevos eventos'
    },
    actions: {
      markAllRead: 'Marcar todo como leido',
      delete: 'Eliminar',
      cancel: 'Cancelar'
    },
    deleteOptions: {
      deleteAll: 'Eliminar todo',
      deleteOlder1Month: 'Eliminar anteriores a 1 mes',
      deleteOlder3Months: 'Eliminar anteriores a 3 meses',
      deleteOlder6Months: 'Eliminar anteriores a 6 meses'
    },
    deleteDialog: {
      title: 'Confirmar accion de eliminacion',
      message: 'Se aplicara: {{action}}. No puedes deshacer esta accion.',
      confirm: 'Confirmar: {{action}}'
    }
  },
  emailTemplates: {
    title: 'Plantillas de correo',
    newTemplate: 'Nueva plantilla',
    adminOnly: 'Esta página solo está disponible para administradores.',
    sendTestEmail: 'Enviar correo de prueba',
    filterByType: 'Filtrar por tipo',
    filterByLanguage: 'Filtrar por idioma',
    all: 'Todos',
    search: 'Buscar',
    searchPlaceholder: 'Tipo, asunto, cuerpo',
    loading: 'Cargando plantillas...',
    noTemplates: 'Ninguna plantilla coincide con los filtros actuales.',
    edit: 'Editar',
    table: {
      action: 'Acción',
      type: 'Tipo',
      language: 'Idioma',
      subject: 'Asunto'
    },
    dialog: {
      saveTitle: 'Guardar plantilla de correo',
      testTitle: 'Enviar correo de prueba',
      typeLabel: 'Tipo',
      languageLabel: 'Idioma',
      languageHelper: 'Elige el idioma de la plantilla',
      subjectLabel: 'Asunto',
      bodyLabel: 'Cuerpo (HTML)',
      bodyHelper: 'Marcadores compatibles: {{Email}}, {{Token}}, {{ConfirmationLink}}, {{ResetLink}}, {{EventTitle}}, {{EventDate}}, {{EventLink}}',
      livePreview: 'Vista previa',
      previewCaption: 'La vista previa usa valores de muestra para verificar los marcadores antes de guardar.',
      toEmailLabel: 'Para (email)',
      templateTypeLabel: 'Tipo de plantilla',
      testLanguageHelper: 'Selecciona la versión de idioma de la plantilla a enviar',
      cancel: 'Cancelar',
      save: 'Guardar',
      send: 'Enviar'
    },
    success: {
      saved: 'Plantilla de correo guardada correctamente.',
      testSent: 'Correo de prueba enviado a {{toEmail}}.'
    },
    errors: {
      backendUnavailable: 'No se puede alcanzar la API en {{baseUrl}}. Inicia la API con: dotnet run --project src/Backend/EventList.Api',
      load: 'Error al cargar las plantillas de correo.',
      save: 'Error al guardar la plantilla de correo.',
      sendTest: 'Error al enviar el correo de prueba.',
      subjectBodyRequired: 'El asunto y el cuerpo son obligatorios.',
      recipientRequired: 'El correo del destinatario es obligatorio.',
      invalidEmail: 'Por favor, introduce una dirección de correo válida.'
    }
  },
  eventTemplates: {
    title: 'Plantillas de evento',
    newTemplate: 'Nueva plantilla',
    adminOnly: 'Esta pagina solo esta disponible para administradores.',
    filterByLanguage: 'Filtrar por idioma',
    all: 'Todos',
    search: 'Buscar',
    searchPlaceholder: 'Tipo, nombre, cuerpo',
    loading: 'Cargando plantillas...',
    noTemplates: 'Ninguna plantilla coincide con los filtros actuales.',
    edit: 'Editar',
    translate: 'Traducir',
    preview: 'Vista previa',
    previewDialog: {
      title: 'Vista previa de la plantilla',
      close: 'Cerrar'
    },
    table: {
      action: 'Accion',
      name: 'Nombre',
      type: 'Tipo',
      language: 'Idioma',
      translations: 'Traducciones',
      completeness: 'Completitud',
      complete: 'Completo',
      incomplete: 'Incompleto',
      preview: 'Vista previa',
      created: 'Creado'
    },
    translateDialog: {
      title: 'Traducir plantilla',
      sourceTemplate: 'Plantilla de origen',
      targetLanguage: 'Idioma de destino',
      noLanguagesAvailable: 'Todos los idiomas tienen traducciones para esta plantilla.',
      save: 'Guardar traduccion',
      cancel: 'Cancelar'
    },
    dialog: {
      saveTitle: 'Guardar plantilla de evento',
      typeLabel: 'Tipo de evento',
      nameLabel: 'Nombre',
      languageLabel: 'Idioma',
      emailBodyLabel: 'Cuerpo de correo (HTML)',
      invitationBodyLabel: 'Cuerpo de pagina de invitacion (HTML)',
      invitationBodyHelper:
        'Se usa para la pagina publica de invitacion (/i/{code}) con acciones RSVP. Marcadores compatibles: {{GuestName}}, {{EventTitle}}, {{EventDateUtc}}, {{Venue}}, {{Address}}, {{InvitationLink}}, {{ScanCode}}, {{TableNumber}}',
      bodyHelper: 'Marcadores compatibles: {{GuestName}}, {{EventTitle}}, {{EventDateUtc}}, {{Venue}}, {{Address}}, {{InvitationLink}}, {{ScanCode}}, {{TableNumber}}',
      smsBodyLabel: 'Cuerpo SMS (texto plano)',
      smsBodyHelper: 'Version SMS opcional con limite corto ({{current}}/{{max}}). Se admiten marcadores.',
      previewImageLabel: 'URL de imagen de vista previa',
      previewImagePlaceholder: 'Sube una imagen para rellenar esta URL',
      previewImageHelper: 'Sube una imagen para generar la URL de vista previa de esta plantilla.',
      uploadPreviewImage: 'Subir imagen de vista previa',
      uploadingPreviewImage: 'Subiendo...',
      removePreviewImage: 'Quitar imagen',
      livePreview: 'Vista previa',
      emailPreviewTitle: 'Vista previa de correo',
      invitationPreviewTitle: 'Vista previa de pagina de invitacion',
      smsPreviewTitle: 'Vista previa de SMS',
      emptyPreview: 'Sin contenido todavia.',
      previewCaption: 'La vista previa usa valores de muestra para verificar los marcadores antes de guardar.',
      cancel: 'Cancelar',
      save: 'Guardar'
    },
    typeOptions: {
      other: 'Otro',
      wedding: 'Boda',
      birthday: 'Cumpleaños',
      conference: 'Conferencia',
      meeting: 'Reunión',
      party: 'Fiesta'
    },
    success: {
      saved: 'Plantilla de evento guardada correctamente.',
      translated: 'Traduccion guardada correctamente.'
    },
    errorDialog: {
      title: 'Error',
      close: 'Cerrar'
    },
    errors: {
      backendUnavailable: 'No se puede alcanzar la API en {{baseUrl}}. Inicia la API con: dotnet run --project src/Backend/EventList.Api',
      load: 'Error al cargar las plantillas de evento.',
      save: 'Error al guardar la plantilla de evento.',
      uploadImage: 'Error al subir la imagen de vista previa.',
      nameBodyRequired: 'El nombre y el cuerpo son obligatorios.',
      nameEmailInvitationRequired: 'El nombre, el cuerpo de correo y el cuerpo de invitacion son obligatorios.',
      smsBodyTooLong: 'El cuerpo SMS no puede superar {{max}} caracteres.',
      translate: 'Error al guardar la traduccion.'
    }
  },
  usersPage: {
    title: 'Usuarios',
    createUser: 'Crear usuario',
    adminOnly: 'Esta página solo está disponible para administradores.',
    loading: 'Cargando usuarios...',
    noUsers: 'No se encontraron usuarios.',
    view: 'Ver',
    edit: 'Editar',
    yes: 'Sí',
    no: 'No',
    table: {
      action: 'Acción',
      email: 'Correo',
      role: 'Rol',
      language: 'Idioma',
      timeZone: 'Zona horaria',
      emailConfirmed: 'Correo confirmado',
      created: 'Creado',
      lastLogin: 'Último acceso'
    },
    createDialog: {
      title: 'Crear usuario',
      emailLabel: 'Correo',
      passwordLabel: 'Contraseña',
      roleLabel: 'Rol',
      preferredLanguageLabel: 'Idioma preferido',
      timeZoneLabel: 'Zona horaria',
      cancel: 'Cancelar',
      create: 'Crear'
    },
    editDialog: {
      title: 'Editar usuario',
      emailLabel: 'Correo',
      roleLabel: 'Rol',
      preferredLanguageLabel: 'Idioma preferido',
      timeZoneLabel: 'Zona horaria',
      emailConfirmedLabel: 'Correo confirmado',
      cancel: 'Cancelar',
      save: 'Guardar'
    },
    viewDialog: {
      title: 'Detalles del usuario',
      email: 'Correo',
      role: 'Rol',
      preferredLanguage: 'Idioma preferido',
      timeZone: 'Zona horaria',
      emailConfirmed: 'Correo confirmado',
      created: 'Creado',
      lastLogin: 'Último acceso',
      userId: 'ID de usuario',
      loadingDetails: 'Cargando detalles del usuario...',
      close: 'Cerrar'
    },
    success: {
      created: 'Usuario creado correctamente.',
      updated: 'Usuario actualizado correctamente.'
    },
    errors: {
      backendUnavailable: 'No se puede alcanzar la API en {{baseUrl}}. Inicia la API con: dotnet run --project src/Backend/EventList.Api',
      load: 'Error al cargar los usuarios.',
      create: 'Error al crear el usuario.',
      update: 'Error al actualizar el usuario.',
      loadDetails: 'Error al cargar los detalles del usuario.',
      emailPasswordRequired: 'El correo y la contraseña son obligatorios.',
      emailRequired: 'El correo es obligatorio.',
      invalidEmail: 'Por favor, introduce una dirección de correo válida.'
    }
  },
  scheduledPage: {
    title: 'Cola',
    adminOnly: 'Esta pagina esta disponible solo para administradores.',
    refresh: 'Actualizar',
    loading: 'Cargando programaciones...',
    noSchedules: 'No se encontraron elementos en la cola.',
    allModesHint: 'Esta pagina incluye eventos inmediatos y programados con su estado de cola y entrega en vivo.',
    nextSchedulerRun: 'Siguiente ejecucion del programador',
    everyMinutes: 'cada {{count}} minuto(s)',
    timeZoneDisplay: 'Horas mostradas en {{timeZone}}',
    summary: {
      total: 'Total',
      completed: 'Completado',
      notCompleted: 'No completado',
      overdue: 'Atrasado',
      queuedNow: 'En cola ahora',
      scheduledMode: 'Modo programado',
      immediateMode: 'Modo inmediato',
      sending: 'Enviando'
    },
    status: {
      completed: 'Completado',
      notCompleted: 'No completado',
      overdue: 'Atrasado'
    },
    queueState: {
      queued: 'En cola',
      idle: 'Sin cola'
    },
    sendDateMode: {
      scheduled: 'Programado',
      immediately: 'Inmediato'
    },
    retry: {
      action: 'Reintentar ahora',
      running: 'Reintentando...',
      success: 'Reintento en cola para "{{title}}".',
      failed: 'Error al reintentar este evento.',
      disabled: {
        completed: 'Este evento ya esta completado.',
        sending: 'La entrega ya esta en progreso para este evento.',
        eventPassed: 'Reintentar ahora solo esta disponible antes de la fecha/hora del evento.'
      }
    },
    filter: {
      label: 'Filtro',
      options: {
        all: 'Todos',
        completed: 'Completado',
        notCompleted: 'No completado',
        overdue: 'Atrasado',
        queuedNow: 'En cola ahora',
        sending: 'Enviando'
      }
    },
    providerFilter: {
      label: 'Filtrar por metodo de envio',
      all: 'Todos los metodos de envio'
    },
    sort: {
      label: 'Ordenar por',
      options: {
        nextRunAsc: 'Proxima ejecucion (primero mas cercana)',
        nextRunDesc: 'Proxima ejecucion (primero mas lejana)',
        scheduledAsc: 'Programado para (primero mas cercano)',
        scheduledDesc: 'Programado para (primero mas lejano)',
        lastSentDesc: 'Ultimo enviado (mas reciente primero)',
        lastAttemptDesc: 'Ultimo intento (mas reciente primero)',
        createdDesc: 'Creado (mas reciente primero)',
        createdAsc: 'Creado (mas antiguo primero)'
      }
    },
    table: {
      eventTitle: 'Evento',
      completed: 'Completado',
      status: 'Estado',
      queueState: 'Cola',
      sendDateMode: 'Modo de envio',
      sendProviders: 'Metodos de envio',
      scheduledAt: 'Programado para',
      nextRun: 'Proxima ejecucion',
      lastAttemptAt: 'Ultimo intento',
      lastSentAt: 'Ultimo enviado',
      deliveryCounts: 'Conteos de entrega',
      deliveryCountsValue: 'Enviados: {{sent}} | Fallidos: {{failed}} | Pendientes: {{pending}}',
      createdAt: 'Creado',
      actions: 'Acciones'
    },
    errors: {
      backendUnavailable: 'No se puede alcanzar la API en {{baseUrl}}. Inicia la API con: dotnet run --project src/Backend/EventList.Api',
      load: 'Error al cargar los elementos programados.'
    }
  },
  peoplePage: {
    title: 'Personas',
    importAvailability: 'Importar disponibilidad (Excel)',
    createPerson: 'Crear persona',
    active: 'Activos',
    archived: 'Archivados',
    searchLabel: 'Buscar',
    searchPlaceholder: 'Buscar por nombre, correo o teléfono',
    pageSize: 'Tamaño de página',
    results: 'Mostrando {{shown}} de {{total}} personas',
    noMatches: 'No hay personas que coincidan con tu búsqueda.',
    loading: 'Cargando personas {{view}}...',
    noArchivedPeople: 'No hay personas archivadas aún.',
    noPeople: 'No hay personas aún. Crea una persona o importa disponibilidad desde un archivo Excel.',
    edit: 'Editar',
    archive: 'Archivar',
    restore: 'Restaurar',
    table: {
      action: 'Acción',
      fullName: 'Nombre completo',
      email: 'Correo',
      phone: 'Teléfono',
      availability: 'Disponibilidad',
      countPerson: 'Cantidad de personas',
      archivedAt: 'Archivado el'
    },
    dialog: {
      createTitle: 'Crear persona',
      editTitle: 'Editar persona',
      fullNameLabel: 'Nombre completo',
      emailLabel: 'Correo',
      phoneLabel: 'Teléfono',
      availabilityLabel: 'Disponibilidad',
      countPersonLabel: 'Cantidad de personas',
      availabilityPlaceholder: 'Ejemplo: Lun-Vie 09:00-18:00',
      cancel: 'Cancelar',
      save: 'Guardar',
      create: 'Crear'
    },
    importDialog: {
      title: 'Importar disponibilidad desde Excel',
      description: 'Sube un archivo Excel para crear o actualizar personas y su disponibilidad en lote.',
      supportedColumns: 'Las columnas compatibles y sus alias se muestran abajo.',
      columnFullName: 'Full Name (o Name)',
      columnEmail: 'Email',
      columnPhone: 'Phone (o Phone Number)',
      columnAvailability: 'Availability (o Available)',
      columnCountPerson: 'Count Person (o Count / People Count / Persons)',
      downloadDemo: 'Descargar Excel de ejemplo',
      chooseFile: 'Seleccionar archivo Excel',
      changeFile: 'Cambiar archivo',
      selectedFile: 'Archivo seleccionado',
      noFileSelected: 'Ningún archivo seleccionado',
      progressText: 'Importando fila {{current}} de {{total}}',
      resultSummary: 'Resultado de importación: añadidos {{added}}, actualizados {{updated}}, omitidos {{skipped}}, fallidos {{failed}}.',
      rowErrorsTitle: 'Errores por fila',
      rowErrorItem: 'Fila {{row}}: {{message}}',
      downloadErrors: 'Exportar filas con error',
      skippedRowsTitle: 'Filas omitidas',
      skippedRowsSummary: 'Se omitieron {{count}} filas porque Full Name y Email estaban vacíos.',
      skippedReason: 'Faltan Full Name y Email',
      downloadSkippedRows: 'Exportar filas omitidas',
      cancel: 'Cancelar',
      import: 'Importar',
      importing: 'Importando...'
    },
    confirmArchive: '¿Archivar a {{name}}?',
    confirmRestore: '¿Restaurar a {{name}}?',
    success: {
      archived: 'Persona archivada correctamente.',
      restored: 'Persona restaurada correctamente.',
      created: 'Persona creada correctamente.',
      updated: 'Persona actualizada correctamente.',
      importComplete: 'Importación de Excel completa. Añadidos {{added}}, actualizados {{updated}}.'
    },
    errors: {
      backendUnavailable: 'No se puede alcanzar la API en {{baseUrl}}. Inicia la API con: dotnet run --project src/Backend/EventList.Api',
      load: 'No se pueden cargar las personas ahora mismo.',
      loadArchived: 'No se pueden cargar las personas archivadas ahora mismo.',
      archive: 'Error al archivar la persona.',
      restore: 'Error al restaurar la persona.',
      create: 'Error al crear la persona.',
      update: 'Error al actualizar la persona.',
      importFailed: 'No se pudo importar este archivo. Sube un archivo .xlsx o .xls válido.',
      importApiError: 'Error al importar personas desde Excel.',
      fileRequired: 'Selecciona un archivo Excel para importar.',
      emptyFile: 'El archivo Excel seleccionado está vacío.',
      fullNameEmailRequired: 'El nombre completo y el correo son obligatorios.',
      invalidEmail: 'Por favor, introduce una dirección de correo válida.'
    },
    freeLimit: {
      reached: 'Has alcanzado el límite de 50 personas del plan gratuito. Actualiza a Premium para acceso ilimitado.',
      upgradeButton: 'Actualizar a Premium'
    },
    pagination: {
      previous: 'Anterior',
      next: 'Siguiente',
      goToPage: 'Ir a página',
      pageOf: 'Página {{page}} de {{totalPages}}'
    }
  },
  financePage: {
    title: 'Finanzas',
    financeButton: 'Finanzas',
    premiumRequired: 'Las finanzas del evento son una función Premium',
    premiumDescription: 'Registra ingresos, gastos y beneficios/pérdidas de tus eventos. Vincula regalos a invitados, compara lo planificado con lo real y consulta resúmenes financieros — todo en un solo lugar.',
    upgradeNow: 'Actualizar ahora',
    total: 'Total',
    entries: 'registros',
    save: 'Guardar',
    cancel: 'Cancelar',
    confirmDelete: '¿Estás seguro de que deseas eliminar este registro?',
    tabs: { budget: 'Presupuesto', income: 'Ingresos', expenses: 'Gastos', summary: 'Resumen' },
    budget: {
      title: 'Presupuesto del evento',
      plannedIncome: 'Ingresos planificados',
      plannedExpenses: 'Gastos planificados',
      expectedGuests: 'Invitados esperados',
      expectedAttendees: 'Asistentes esperados',
      notes: 'Notas',
      save: 'Guardar presupuesto',
      saved: 'Presupuesto guardado correctamente',
      plannedProfit: 'Beneficio planificado'
    },
    income: {
      title: 'Ingresos', addIncome: 'Añadir ingreso', editIncome: 'Editar ingreso', noEntries: 'Aún no hay registros de ingresos.',
      category: 'Categoría', amount: 'Importe', description: 'Descripción', guest: 'Invitado',
      receivedAt: 'Fecha de recepción', anonymous: 'Regalo anónimo', groupGift: 'Regalo colectivo', groupSize: 'Número de contribuyentes',
      categories: { Gift: 'Regalo', TicketSale: 'Venta de entradas', Sponsorship: 'Patrocinio', Donation: 'Donación', Other: 'Otro' }
    },
    expenses: {
      title: 'Gastos', addExpense: 'Añadir gasto', editExpense: 'Editar gasto', noEntries: 'Aún no hay registros de gastos.',
      category: 'Categoría', vendor: 'Proveedor / Suministrador', description: 'Descripción',
      planned: 'Planificado', actual: 'Real', status: 'Estado del pago', dueDate: 'Fecha de vencimiento',
      categories: { Venue: 'Lugar', Catering: 'Catering', Decoration: 'Decoración', Photography: 'Fotografía', Entertainment: 'Entretenimiento', Marketing: 'Marketing', Transportation: 'Transporte', Accommodation: 'Alojamiento', Other: 'Otro' },
      paymentStatuses: { Planned: 'Planificado', Paid: 'Pagado', PartiallyPaid: 'Parcialmente pagado' }
    },
    summary: {
      title: 'Resumen financiero', incomeCard: 'Ingresos', expensesCard: 'Gastos', resultCard: 'Resultado',
      plannedIncome: 'Ingresos planificados', actualIncome: 'Ingresos reales', incomeVariance: 'Variación de ingresos',
      plannedExpenses: 'Gastos planificados (presupuesto)', entryPlannedExpenses: 'Gastos planificados (registros)',
      actualExpenses: 'Gastos reales', expenseVariance: 'Variación de gastos', profitLoss: 'Beneficio / Pérdida',
      budgetVariance: 'Variación del presupuesto', guestInsights: 'Datos de invitados', giftsCount: 'Regalos recibidos',
      totalGifts: 'Total regalos', avgGift: 'Regalo promedio', incomePerAttendee: 'Ingresos por asistente', checkedIn: 'Asistentes registrados'
    },
    errors: { loadFailed: 'Error al cargar los datos financieros.', saveFailed: 'Error al guardar. Por favor, inténtalo de nuevo.' }
  },
  eventMediaPage: {
    title: 'Multimedia',
    mediaButton: 'Multimedia',
    description: 'Recopila fotos y vídeos de este evento.',
    upload: 'Subir',
    empty: 'Todavía no hay fotos ni vídeos.',
    premiumRequired: 'Subir contenido multimedia del evento es una función Premium.',
    upgradeNow: 'Mejorar ahora',
    select: 'Seleccionar',
    cancelSelect: 'Cancelar',
    downloadAll: 'Descargar todo',
    downloadSelected: 'Descargar seleccionados ({{count}})',
    uploadedBy: 'De: {{name}}',
    errors: {
      loadFailed: 'Error al cargar el contenido multimedia.',
      uploadFailed: 'Error al subir el archivo. Por favor, inténtalo de nuevo.',
      deleteFailed: 'Error al eliminar el archivo. Por favor, inténtalo de nuevo.',
      downloadFailed: 'Error al descargar el archivo. Por favor, inténtalo de nuevo.',
      downloadZipFailed: 'Error al descargar los archivos. Por favor, inténtalo de nuevo.'
    }
  },
  eventGalleryPage: {
    title: 'Galería de Invitados',
    galleryButton: 'Galería de Invitados',
    description: 'Permite que tus invitados compartan sus propias fotos y vídeos después del evento mediante un enlace compartido.',
    notEnabled: 'La galería de invitados aún no está habilitada para este evento.',
    enable: 'Habilitar Galería de Invitados',
    enabling: 'Habilitando...',
    linkLabel: 'Enlace de la galería',
    copyLink: 'Copiar enlace',
    linkCopied: 'Enlace copiado al portapapeles.',
    expiresLabel: 'Los invitados pueden subir contenido hasta',
    send: 'Enviar enlace a los invitados',
    sending: 'Enviando...',
    sendSuccess: 'Enlace de la galería enviado a {{count}} invitado(s).',
    premiumRequired: 'La galería de invitados es una función Premium.',
    upgradeNow: 'Mejorar ahora',
    disable: 'Deshabilitar Galería',
    disabling: 'Deshabilitando...',
    disabledNotice: 'La galería de invitados está deshabilitada actualmente. Los invitados ya no pueden ver ni subir fotos.',
    reEnable: 'Volver a Habilitar Galería',
    viewModeAllPhotos: 'Los invitados pueden ver todas las fotos',
    errors: {
      loadFailed: 'Error al cargar la configuración de la galería.',
      enableFailed: 'Error al habilitar la galería de invitados. Por favor, inténtalo de nuevo.',
      sendFailed: 'Error al enviar el enlace de la galería. Por favor, inténtalo de nuevo.',
      disableFailed: 'Error al deshabilitar la galería de invitados. Por favor, inténtalo de nuevo.',
      viewModeFailed: 'Error al actualizar la configuración de visualización. Por favor, inténtalo de nuevo.'
    }
  },
  eventWishlistPage: {
    title: 'Lista de Regalos',
    wishlistButton: 'Lista de Regalos',
    description: 'Añade regalos que los invitados puedan elegir traer. Quienes confirmen asistencia reciben un enlace a esta lista por correo.',
    addItem: 'Añadir Regalo',
    editItem: 'Editar Regalo',
    empty: 'Todavía no se han añadido regalos.',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    addSuccess: 'Se añadió "{{name}}" a la lista de regalos.',
    updateSuccess: 'Se actualizó "{{name}}".',
    deleteSuccess: 'Se eliminó "{{name}}" de la lista de regalos.',
    deleteConfirmTitle: '¿Eliminar regalo?',
    deleteConfirmMessage: '¿Seguro que quieres eliminar "{{name}}" de la lista de regalos?',
    table: {
      name: 'Nombre',
      description: 'Descripción',
      link: 'Enlace',
      status: 'Estado',
      reservedBy: 'Reservado por'
    },
    status: {
      available: 'Disponible',
      pending: 'Pendiente de confirmación',
      confirmed: 'Reservado'
    },
    form: {
      name: 'Nombre del regalo',
      description: 'Descripción breve',
      purchaseUrl: 'Enlace de compra'
    },
    errors: {
      loadFailed: 'Error al cargar la lista de regalos.',
      saveFailed: 'Error al guardar el regalo. Por favor, inténtalo de nuevo.',
      deleteFailed: 'Error al eliminar el regalo. Por favor, inténtalo de nuevo.'
    }
  },
  publicGallery: {
    title: 'Galería de Invitados',
    loading: 'Cargando galería...',
    subtitle: 'Fotos y vídeos compartidos por invitados de {{eventTitle}}',
    expiresNotice: 'Los invitados pueden añadir fotos/vídeos hasta {{date}}.',
    expiredNotice: 'Esta galería ya no acepta nuevas subidas, pero aún puedes ver lo que se ha compartido.',
    disabledNotice: 'Esta galería ha sido cerrada por el anfitrión.',
    ownUploadsNotice: 'Solo estás viendo las fotos y vídeos que subiste desde este dispositivo.',
    uploaderLabelPlaceholder: 'Tu nombre (opcional)',
    upload: 'Añadir foto/vídeo',
    uploading: 'Subiendo...',
    uploadDisclaimer: 'Al subir contenido aquí, tu foto o vídeo será visible para todos los invitados de este evento. Asegúrate de tener el consentimiento de cualquier persona que aparezca en tu contenido. El organizador puede eliminar cualquier elemento en cualquier momento.',
    empty: 'Todavía no hay fotos ni vídeos. ¡Sé el primero en compartir!',
    uploadedBy: 'De: {{name}}',
    errors: {
      backendUnavailable: 'No se puede conectar con la API backend en {{baseUrl}}. Inicia la API con: dotnet run --project src/Backend/EventList.Api',
      invalidGallery: 'Este enlace de galería no es válido o ha caducado.',
      loadGallery: 'No se puede cargar esta galería en este momento.',
      uploadFailed: 'Error al subir el archivo. Por favor, inténtalo de nuevo.'
    }
  },
  publicWishlist: {
    title: 'Lista de Regalos',
    loading: 'Cargando lista de regalos...',
    subtitle: 'Ideas de regalos para {{eventTitle}}',
    empty: 'Todavía no se han añadido regalos.',
    viewLink: 'Ver regalo',
    reserve: 'Yo lo traigo',
    reserving: 'Reservando...',
    release: 'Cancelar mi reserva',
    releasing: 'Cancelando...',
    reservedByMe: 'Has reservado este regalo. Revisa tu correo para confirmarlo en los próximos 60 minutos.',
    confirmedByMe: 'Has confirmado este regalo. ¡Gracias!',
    unavailable: 'Ya ha sido reservado por otro invitado',
    attendingRequiredNotice: 'Solo los invitados que confirmaron asistencia pueden reservar un regalo.',
    errors: {
      backendUnavailable: 'No se puede conectar con la API backend en {{baseUrl}}. Inicia la API con: dotnet run --project src/Backend/EventList.Api',
      invalidInvitation: 'Este enlace no es válido o ha caducado.',
      loadFailed: 'No se puede cargar la lista de regalos en este momento.',
      reserveFailed: 'No se pudo reservar este regalo. Puede que alguien más lo acabe de reservar.',
      releaseFailed: 'No se pudo cancelar tu reserva en este momento.'
    }
  },
  publicWishlistConfirm: {
    title: 'Confirma tu reserva de regalo',
    confirming: 'Confirmando tu reserva...',
    successTitle: '¡Reserva confirmada!',
    successMessage: '¡Gracias! Tu reserva de "{{itemName}}" ha sido confirmada.',
    failureTitle: 'Este enlace ya no es válido',
    backToWishlist: 'Volver a la lista de regalos'
  }
};

export default es;
